import { useEffect } from 'react';

const instagramIntegration: React.FC = () => {
  useEffect(() => {
    // Extract the base path without the wsp_success part
    const currentPathname = window.location.pathname;
    const integrationsPath = currentPathname.substring(0, currentPathname.lastIndexOf('/instagram'));
    
    // Create the target URL
    const targetUrl = new URL(integrationsPath, window.location.origin);
    targetUrl.searchParams.set('status', 'success');
    targetUrl.searchParams.set('service', 'Instagram');

    window.location.replace(targetUrl.href);
  });

  // This is just a fallback UI in case the redirect doesn't happen immediately
  return (
    <div>
      <h1>¡Integración con Instagram Exitosa!</h1>
      <p>
        Redirigiendo a la página de integraciones...
      </p>
    </div>
  );
};

export default instagramIntegration;
